import authApiService from "./userApiService";

const handleError = (error) => {
  console.error("Role Management API Error:", error);
  return {
    success: false,
    error: error.response?.data?.error || error.message || "An error occurred",
    statusCode: error.response?.status
  };
};

const handleSuccess = (response) => ({
  success: true,
  data: response.data?.data ?? response.data,
  message: response.data?.message,
  statusCode: response.status
});

export const roleManagementService = {
  /**
   * Get all roles with user and employee counts.
   */
  async getAllRoles() {
    try {
      const response = await authApiService.get("/role-management");
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Create a new dynamic role.
   */
  async createRole(roleName) {
    try {
      const response = await authApiService.post("/role-management", { role: roleName });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Update an existing role name.
   */
  async updateRole(id, roleName) {
    try {
      const response = await authApiService.put(`/role-management/${id}`, { role: roleName });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  /**
   * Delete a custom role.
   */
  async deleteRole(id) {
    try {
      const response = await authApiService.delete(`/role-management/${id}`);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  }
};

export default roleManagementService;
